import React,{useState} from 'react'

export default function LengthConversions() {

    /**New change */
    const [ms, setMs] = useState(0) // - done
    const [cms, setCms] = useState(0)
    const [kms, setKms] = useState(0)
    const [mms, setMms] = useState(0)
    const [fts, setFts] = useState(0)
    const [ins, setIns] = useState(0)
    const [mls, setMls] = useState(0)
    const [yds, setYds] = useState(0)
    
    /**Disabling the mouse wheel */
    const inputFields = document.querySelectorAll('.highlight');
    inputFields.forEach(function(inputField) {
            inputField.addEventListener('wheel', function(event) {
            event.preventDefault();
        });
    })

  return (


    <div >
        <div  style={{display:"flex", justifyContent:"center"}}>
            <h2 style={{color:"#F9D081"}}>Length Conversions</h2>
        </div>
      <div className="grid-container">

            
        
            <div  >
                <div><label id="myLabels" htmlFor="number">Meters (m)</label></div>
                
                <input 
                className="highlight"
                type="number" 
                value={ms}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a)
                    setCms(a*100)
                    setKms(a*0.001)
                    setMms(a*1000)
                    setIns(a*3.28084)
                    setFts(a*39.3701)
                    setYds(a*1.09361)
                    setMls(a*0.000621371)
            }}/></div> 


            <div  >
                <div><label id="myLabels" htmlFor="number">Centimeters (cm)</label></div>
                
                <input 
                className="highlight"
                value={cms} type="number" 
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*0.01)
                    setCms(a)
                    setKms(a*0.00001)
                    setMms(a*10)
                    setIns(a*0.393701)
                    setFts(a*0.0328084)
                    setYds(a*0.0109361)
                    setMls(a*0.00000621371)
            }}/></div>       


<div  >
                <div><label id="myLabels" htmlFor="number">Kilometers (km)</label></div>
                
                <input 
                className='highlight'
                type="number" value={kms}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*1000)
                    setCms(a*100000)
                    setKms(a)
                    setMms(a*1000000)
                    setIns(a*39370.1)
                    setFts(a*3280.84)
                    setYds(a*1093.61)
                    setMls(a*0.621371)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Millimeters (mm)</label></div>
                
                <input 
                className='highlight'
                type="number" value={mms}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*0.001)
                    setCms(a*0.1)
                    setKms(a*0.000001)
                    setMms(a)
                    setIns(a*0.0393701)
                    setFts(a*0.00328084)
                    setYds(a*0.00109361)
                    setMls(a*0.000000621371)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Feet (ft)</label></div>
                
                <input 
                className='highlight'
                type="number" value={fts}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*0.3048)
                    setCms(a*30.48)
                    setKms(a*0.0003048)
                    setMms(a*304.8)
                    setIns(a*12)
                    setFts(a)
                    setYds(a*0.333333)
                    setMls(a*0.000189394)
            }}/></div>

<div  >
                <div><label id="myLabels" htmlFor="number">Inches (in)</label></div>
                
                <input 
                className='highlight'
                type="number" value={ins}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*0.0254)
                    setCms(a*2.54)
                    setKms(a*0.0000254)
                    setMms(a*25.4)
                    setIns(a)
                    setFts(a*0.0833333)
                    setYds(a*0.0277778)
                    setMls(a*0.0000157828)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Yards (yd)</label></div>
                
                <input 
                className='highlight'
                type="number" value={yds}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*0.9144)
                    setCms(a*91.44)
                    setKms(a*0.0009144)
                    setMms(a*914.4)
                    setIns(a*36)
                    setFts(a*3)
                    setYds(a)
                    setMls(a*0.000568182)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Miles (mi)</label></div>
                
                <input 
                className='highlight'
                type="number" value={mls}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMs(a*1609.34)
                    setCms(a*160934)
                    setKms(a*1.60934)
                    setMms(a*1609340)
                    setIns(a*63360)
                    setFts(a*5280)
                    setYds(a*1760)
                    setMls(a)
            }}/></div>

   
        </div> 

        <div  style={{display:"flex", justifyContent:"center"}}>
        <button className='clear-button' onClick={(e) => {
        setKms(0)
        setCms(0)
        setMms(0)
        setMs(0)
        setFts(0)
        setIns(0)
        setMls(0)
        setYds(0)
    }}>
        Clear Button
    </button>
        </div>
    </div>


  )
}
    // const [lengthMI, setLengthMI] = useState();
    // const [lengthMF, setLengthMF] = useState();
    // const [lengthMY, setLengthMY] = useState();
    // const [lengthKM, setLengthKM] = useState();

        // const lengthMetersToInches = 39.3701; //lengthMI
    // const lengthMetersToFeet = 3.28084; //lengthMF
    // const lengthMetersToYards = 1.09361; //lengthMY
    // const lengthKilometersToMiles = 0.621371; //lengthKM


    // <div>
    //   <div className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>
    //     <div style={{display:"flex", justifyContent:"center"}}>
    //     <h2 style={{color:"#F9D081"}}>Length Conversions</h2>
    //     </div>
            
    //     <div  id="rows">
    //         <div  id="cols">
    //             <div><label id="myLabels" htmlFor="number">Meters</label></div>
                
    //             <input type="number" onChange={(e) => {
    //             setLengthMI(e.target.value*lengthMetersToInches)
    //         }}/></div>
    //         <div >
    //             <div><label id="myLabels" htmlFor="number">Inches</label></div>
    //         <input type="text" value={lengthMI} disabled/>
    //         </div>
    //     </div>

    //     <div  id="rows">
    //         <div  id="cols">
    //             <div><label id="myLabels" htmlFor="number">Meters</label></div>
                
    //             <input type="number" onChange={(e) => {
    //             setLengthMY(e.target.value*lengthMetersToYards)
    //         }}/></div>
    //         <div >
    //             <div><label id="myLabels" htmlFor="number">Yards</label></div>
    //         <input type="text" value={lengthMY} disabled/>
    //         </div>
    //     </div>

    //     <div  id="rows">
    //         <div  id="cols">
    //             <div><label id="myLabels" htmlFor="number">Meters</label></div>
                
    //             <input type="number" onChange={(e) => {
    //             setLengthMF(e.target.value*lengthMetersToFeet)
    //         }}/></div>
    //         <div >
    //             <div><label id="myLabels" htmlFor="number">Feet</label></div>
    //         <input type="text" value={lengthMF} disabled/>
    //         </div>
    //     </div>

    //     <div  id="rows">
    //         <div  id="cols">
    //             <div><label id="myLabels" htmlFor="number">Kilometers</label></div>
                
    //             <input type="number" onChange={(e) => {
    //             setLengthKM(e.target.value*lengthKilometersToMiles)
    //         }}/></div>
    //         <div >
    //             <div><label id="myLabels" htmlFor="number">Miles</label></div>
    //         <input type="text" value={lengthKM} disabled/>
    //         </div>
    //     </div>
    //     </div> 
    // </div>

